module.exports = __webpack_public_path__ + "img/Status-Server Monitor-Report-Up-1.99d85d1d.svg";